/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useState } from 'react';
import { Fade } from 'react-awesome-reveal';
import { useDispatch, useSelector } from 'react-redux';
import classes from './RightSideBar.module.scss';

import Favorites from 'components/home/favorites/Favorites';
import {
  CUSTOMER_VIEW_TEXT,
  INSIGHT_TYPE,
  INSIGHTS_DEFAULT_TEXT,
  INSIGHT_TYPE_CODE,
  NUMBER_ZERO,
  DASHBOARD_IB_LENGTH,
} from 'constants/constants';
import { Row } from 'react-bootstrap';
import { Link } from 'react-router-dom';
import {
  getAllInsightBoards,
  getInsightViews,
} from 'store/customer/customer-view-actions';
import {
  setAllInsightView,
  setCards,
  setCustomerInsightBoardId,
  setFocusAccountChecked,
  setInsightType,
  setSelectedAccountId,
  setSelectedCustomer,
  setSelectedInsightView,
  setSeletedView,
} from 'store/customer/customerViewSlice';

const RightSideBar = () => {
  const dispatch = useDispatch();

  const { unixId, roleId } = useSelector((state) => state.Auth.userClaimObject);

  const insightsBoards = useSelector(
    (state) => state?.CustomerView?.insightBoards
  );

  useEffect(() => {
    dispatch(getAllInsightBoards(unixId, roleId));
  }, [dispatch]);

  const itemClickHandler = async (insight) => {
    dispatch(setSeletedView(insight?.label?.toLowerCase()));
    dispatch(setInsightType(INSIGHT_TYPE.GENERAL));
    dispatch(setCards([]));
    dispatch(
      setSelectedCustomer({
        value: insight.accountId,
        label: insight.accountName,
        veevaId: insight?.veevaId,
        flag: insight?.flag,
      })
    );

    let isPriorityAccount = insight?.isPriorityAccount === 'Y' ? true : false;
    dispatch(setSelectedAccountId(insight.accountId));
    dispatch(setCustomerInsightBoardId(insight.Id));
    dispatch(setFocusAccountChecked(isPriorityAccount));

    // Call Insight Views API
    const response = await getInsightViews(
      insight.Id,
      insight.insightType === INSIGHT_TYPE.SAMPLE
        ? INSIGHT_TYPE_CODE.SAMPLE
        : INSIGHT_TYPE_CODE.GENERAL
    );
    // Set All Insight View and Selected Insight View
    dispatch(setAllInsightView(response?.data?.result ?? []));
    dispatch(
      setSelectedInsightView(response?.data?.result?.[NUMBER_ZERO] ?? {})
    );
  };

  return (
    <aside className={`${classes['right-side-bar']}`}>
      {/*insights section*/}
      <section className='divider'>
        <Fade>
          <Row>
            <p className='title__normal title__bold d-flex align-items-center'>
              <i className='icon icon__insights'></i>Insight Boards
            </p>
          </Row>
        </Fade>

        <Fade cascade>
          {insightsBoards
            ?.slice(NUMBER_ZERO, DASHBOARD_IB_LENGTH)
            .map((item, index) => {
              return (
                item.insightType !== INSIGHT_TYPE.SAMPLE && (
                  <Row key={index}>
                    <p className='title__small'>
                      <Link
                        to={
                          '/customerView/list/' +
                          item.name.replace(CUSTOMER_VIEW_TEXT, '')
                        }
                        onClick={() => itemClickHandler(item)}>
                        {item.name.replace(CUSTOMER_VIEW_TEXT, '')}
                      </Link>
                    </p>
                  </Row>
                )
              );
            })}
        </Fade>
        {insightsBoards?.length > DASHBOARD_IB_LENGTH - 1 ? (
          <Fade>
            <Row>
              <Link to='/customerView/list'>
                <div
                  className={`${classes['view-all-class-btn']} title__small title__blue title__bold`}>
                  View All
                </div>
              </Link>
            </Row>
          </Fade>
        ) : (
          ''
        )}

        {!insightsBoards ? (
          <Fade>
            <Row>
              <p>{INSIGHTS_DEFAULT_TEXT}</p>
            </Row>
          </Fade>
        ) : (
          ''
        )}
      </section>

      {/*favorites section*/}
      <section>
        <Fade cascade>
          <Favorites></Favorites>
        </Fade>
      </section>
    </aside>
  );
};

export default RightSideBar;
